import type { RohsComponentComplianceFileDetailView } from '@/shared/hooks/api/rohsComplianceFiles'
import { isRohsTestReportAuditStale } from '@/shared/rohs/isRohsTestReportAuditStale'

const ROHS_TEST_REPORT_AUDIT_POLL_MS = 2000

export function rohsTestReportAuditRefetchInterval(query: {
  state: { data?: RohsComponentComplianceFileDetailView }
}): number | false {
  const file = query.state.data
  if (file == null) {
    return false
  }
  if (isRohsTestReportAuditStale(file)) {
    return ROHS_TEST_REPORT_AUDIT_POLL_MS
  }
  return false
}
